import {Controller} from "stimulus"
import AutoNumeric from "autonumeric";

export default class extends Controller {
    static targets = ["sendButton"]

    connect() {
        if (document.querySelector('.schedule-area')) {
            const currentInspectorId = getCurrentInspector();
            showSchedule(currentInspectorId);
        }
        this.cacheAttemptSyncElements();
        this.bindAttemptSyncListeners();
        this.toggleSendButton();
    }

    refreshSchedule(e) {
        let scheduleDate = getScheduleDate();
        const scheduleArea = document.querySelector('.schedule-area');
        if (!scheduleArea) {
            return;
        }
        if (!scheduleDate) {
            scheduleArea.innerHTML = '';
            return;
        }
        const inspectorId = getCurrentInspector();
        let url = "/inspection_schedules?for_date=" + encodeURIComponent(scheduleDate);
        if (inspectorId) {
            url += "&inspector_id=" + encodeURIComponent(inspectorId);
        }
        fetch(url)
            .then(response => response.text())
            .then(html => {
                scheduleArea.outerHTML = html;
            });
    }

    toggleSchedule(e) {
        e.preventDefault();
        const currentInspectorId = e.currentTarget.dataset.inspector;
        toggleSchedule(currentInspectorId);
    }

    displayInspectorSchedule(e) {
        const inspectorId = e.target.value;
        let scheduleDate = getScheduleDate();
        const scheduleArea = document.querySelector('.schedule-area');
        if (!scheduleArea) {
            return;
        }
        if (!scheduleDate) {
            // Fall back to toggling if no date is set
            var schedules = document.querySelectorAll(".inspector-schedule")
            schedules.forEach(function (schedule) {
                schedule.hidden = true
                let button = document.querySelector('[aria-controls="' + schedule.id + '"]');
                if (button) { button.setAttribute('aria-expanded', 'false'); }
                let id = schedule.id.replace('Inspector-', '');
                let chevron = document.querySelector('[data-schedule-chevron="' + id + '"]');
                if (chevron) { chevron.style.transform = ''; }
            })
            showSchedule(inspectorId)
            return;
        }
        let url = "/inspection_schedules?for_date=" + encodeURIComponent(scheduleDate);
        if (inspectorId) {
            url += "&inspector_id=" + encodeURIComponent(inspectorId);
        }
        fetch(url)
            .then(response => response.text())
            .then(html => {
                scheduleArea.outerHTML = html;
            });
    }

    // Enables the Send button when at least one recipient exists:
    // - An implicit recipient (e.g. applicant email set server-side via data-has-implicit-recipient)
    // - A checked contact checkbox
    // - A non-empty additional_emails free-form field
    toggleSendButton() {
        if (!this.hasSendButtonTarget) return;

        const hasImplicit = this.sendButtonTarget.dataset.hasImplicitRecipient === "true";
        const checkboxes = this.element.querySelectorAll('input[name="recipients[]"]');
        const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
        const emailField = this.element.querySelector('input[name="additional_emails"]');
        const hasEmail = emailField && emailField.value.trim().length > 0;

        this.sendButtonTarget.disabled = !hasImplicit && !anyChecked && !hasEmail;
    }

    inspectionSent(e) {
        console.log("inspection sent")
        // close the modal and add a message to #flash-area that the inspection has been sent
        e.target.closest('.popup-form').classList.remove('editing');
        document.getElementById('flash-area').innerHTML = "<div class='rounded-md bg-green-50 p-4 m-2 border-2 border-green-800'>Inspection has been sent</div>";
    }

    cacheAttemptSyncElements() {
        this.inspectionStateField = document.getElementById('inspection_state');
        this.inspectionAssigneeField = document.getElementById('inspection_assignee_id');
        this.attemptStateField = this.element.querySelector('[data-inspection-attempt-state]');
        this.attemptAssigneeField = this.element.querySelector('[data-inspection-attempt-assignee]');
        this.attemptSyncModeField = this.element.querySelector('[data-attempt-sync-mode]');
        this.syncInspectionCheckbox = this.element.querySelector('[data-sync-inspection-with-attempt]');
    }

    bindAttemptSyncListeners() {
        if (!this.attemptSyncModeField) {
            return;
        }
        if (this.inspectionStateField) {
            this.inspectionStateField.addEventListener('change', () => this.syncAttemptFromInspection());
        }
        if (this.inspectionAssigneeField) {
            this.inspectionAssigneeField.addEventListener('change', () => this.syncAttemptFromInspection());
        }
        if (this.attemptStateField) {
            this.attemptStateField.addEventListener('change', () => this.markAttemptManual());
        }
        if (this.attemptAssigneeField) {
            this.attemptAssigneeField.addEventListener('change', () => this.markAttemptManual());
        }
    }

    markAttemptManual() {
        if (this.isSyncingAttempt) {
            return;
        }
        if (this.attemptSyncModeField) {
            this.attemptSyncModeField.value = 'manual';
        }
    }

    syncAttemptFromInspection() {
        if (!this.attemptSyncModeField || this.attemptSyncModeField.value !== 'auto') {
            return;
        }
        this.isSyncingAttempt = true;
        if (this.attemptStateField && this.inspectionStateField) {
            this.attemptStateField.value = this.inspectionStateField.value;
        }
        if (this.attemptAssigneeField && this.inspectionAssigneeField) {
            this.attemptAssigneeField.value = this.inspectionAssigneeField.value;
            this.attemptAssigneeField.dispatchEvent(new Event('change'));
        }
        this.isSyncingAttempt = false;
    }

    confirmAttemptSync(event) {
        if (!this.attemptStateField && !this.attemptAssigneeField) {
            return;
        }
        if (!this.syncInspectionCheckbox) {
            return;
        }
        const stateDiff = this.inspectionStateField && this.attemptStateField &&
            this.inspectionStateField.value !== this.attemptStateField.value;
        const assigneeDiff = this.inspectionAssigneeField && this.attemptAssigneeField &&
            this.inspectionAssigneeField.value !== this.attemptAssigneeField.value;
        if ((stateDiff || assigneeDiff) && !this.syncInspectionCheckbox.checked) {
            const proceed = confirm("Attempt status/assignee differs from the inspection. Save without syncing?");
            if (!proceed) {
                event.preventDefault();
            }
        }
    }

}

function toggleSchedule(inspectorId) {
    let inspectorElement = document.getElementById('Inspector-' + inspectorId);
    if (inspectorElement) {
        inspectorElement.hidden = !inspectorElement.hidden;
        let button = document.querySelector('[aria-controls="Inspector-' + inspectorId + '"]');
        if (button) {
            button.setAttribute('aria-expanded', String(!inspectorElement.hidden));
        }
        let chevron = document.querySelector('[data-schedule-chevron="' + inspectorId + '"]');
        if (chevron) {
            chevron.style.transform = inspectorElement.hidden ? '' : 'rotate(90deg)';
        }
    }
}

function showSchedule(inspectorId) {
    let inspectorElement = document.getElementById('Inspector-' + inspectorId);
    if (inspectorElement) {
        inspectorElement.hidden = false;
        let button = document.querySelector('[aria-controls="Inspector-' + inspectorId + '"]');
        if (button) {
            button.setAttribute('aria-expanded', 'true');
        }
        let chevron = document.querySelector('[data-schedule-chevron="' + inspectorId + '"]');
        if (chevron) {
            chevron.style.transform = 'rotate(90deg)';
        }
    }
}

function getCurrentInspector() {
    // Prefer the visit's performed_by (current attempt inspector) over the
    // inspection-level assignee so the schedule expands the correct inspector.
    // Check standalone visit edit field, then nested visit fields on the
    // inspection edit page, and finally fall back to inspection-level assignee.
    // If a field exists but has a blank value (prompt selected), skip it.
    let field = document.getElementById('inspection_visit_performed_by_id');
    if (field && field.value) return field.value;

    field = document.querySelector('[id^="inspection_inspection_visits_attributes_"][id$="_performed_by_id"]');
    if (field && field.value) return field.value;

    field = document.getElementById('inspection_assignee_id');
    return field ? field.value : '';
}

function getScheduleDate() {
    let field = document.getElementById('inspection_inspection_visits_attributes_0_scheduled_for') ||
                document.getElementById('inspection_visit_scheduled_for');
    return field ? field.value : '';
}
